import template from './information-management.html';
import controller from './information-management.controller';

let informationManagementComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default informationManagementComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/information-management/information-management.component.js